import {
  fetchTableData as fetchTbDataApi,
  fetchTableDataCount as fetchTableDataCountApi,
  createTbData as createTbDataApi,
  updateTbData as updateTbDataApi,
  batchUpdateTbData as batchUpdateTbDataApi,
  batchDestroyTbData as batchDestroyTbDataApi,
  fetchTableDataEnhance as fetchTableDataEnhanceApi,
} from '@vt/apis/lib-ex/v2/tables'
import { omit, castArray, isArray, head, isBoolean } from 'lodash-es'

import Base from './base'

export default class Ditto extends Base {
  constructor(appId, tbId, vtProject) {
    super(appId, tbId, vtProject)

    // this.tbId = tbId

    // this.idFiledName = 'objectId'
    this.dbSpeqcPrefix = `tbi_ditto_${this.tbId}`
    if (this.tbDefs.info && this.tbDefs.idFieldName) {
      this.idFiledName = this.tbDefs.idFieldName
    } else {
      this.idFiledName = 'objectId'
    }

    // this.dbSpecPrefix = 'ditto'
  }

  get dbSpecId() {
    return `${this.dbSpecPrefix}_lsd`
  }

  // 针对新建、编辑单独写一个可预处理数据的
  // async createAndDeal(items) {
  //   const dealedData = await this.dealLazyData(items)
  //   return dealedData
  // }

  afterDataChanged(tbData) {
    this.store(tbData)
    this.dealLazyData(tbData)
  }

  afterDataDeleted(ids) {
    this.processedData = omit(this.processedData, ids)
    // this.preProcessData(tbData)
  }

  fetchTbDataRaw({
    filters,
    sorts = {},
    pageSize,
    pageNum,
    fields,
    extParams,
    useAuth,
  }) {
    const { extend = {} } = this.tbDefs
    const { realCount } = extend
    const fetch = fields ? fetchTableDataEnhanceApi : fetchTbDataApi
    return fetch(
      this.appId,
      this.tbId,
      {
        filters,
        sorts,
        fields,
      },
      {
        size: pageSize,
        page: pageNum,
        ...extParams,
      },
      realCount,
      isBoolean(useAuth) ? useAuth : this.useAuth
    )
  }

  // 获取表单数据总数
  fetchTableDataCount({ filters, sorts = {}, pageSize, pageNum, fields }) {
    return fetchTableDataCountApi(
      this.appId,
      this.tbId,
      {
        filters,
        sorts,
      },
      {
        size: pageSize,
        page: pageNum,
        fields,
      }
    ).then((total) => {
      this.total = total
      return total
    })
  }

  // 获取远程数据
  fetchTbData(params) {
    const props = {}

    return this.fetchTbDataRaw({ ...(params || {}) }).then(async (res) => {
      const { tbData, total, totalPages } = res
      this.total = total
      this.totalPages = totalPages
      // this.afterDataChanged(tbData)
      const dealedData = await this.dealLazyData(tbData)
      return dealedData
    })
  }

  fetchTbDataLast(pageSize) {
    return this.fetchTbData({
      sorts: [{ slug: 'createdAt', order: 'desc' }],
      pageSize,
    })
  }

  fetchTbDataAll() {
    return this.fetchTbData({
      pageSize: 1000,
    })
  }

  fetchTbOriginalData(params) {
    return this.fetchTbDataRaw(params).then(async (res) => {
      const { tbData } = res
      return tbData
    })
  }

  /**
   *
   * @param {*} id 数据的objectId
   * @param {*} filters 附加筛选条件，非必传
   * @returns
   */
  async fetchById(id, filters) {
    const datum = await this.fetchByIds(id, filters)

    return isArray(datum) ? head(datum) : null
  }

  // 新建表单数据
  createTbData(item) {
    return createTbDataApi(this.appId, this.tbId, item).then((newItem) => {
      this.afterDataChanged([newItem])
      return newItem
    })
  }

  updateTbData(item) {
    return updateTbDataApi(this.appId, this.tbId, item).then((updateItem) => {
      this.afterDataChanged([updateItem])
      return updateItem
    })
  }

  // 批量编辑表单数据
  batchUpdateTbData(data, objectIds) {
    return batchUpdateTbDataApi(this.appId, this.tbId, {
      ...data,
      objectIds,
    }).then((updatedData) => {
      this.afterDataChanged(updatedData)
      // 执行预处理
      return updatedData
    })
  }

  // 删除表单数据-批量
  destroyTbData(objectIds) {
    const ids = castArray(objectIds)
    return batchDestroyTbDataApi(this.appId, this.tbId, ids).then(() => {
      // this.data = omit(this.data, ids)
      // this.processedData = omit(this.processedData, ids)
      this.afterDataDeleted(ids)
      return null
    })
  }

  // 将数据移到回收站-批量
  destroyTbDataToRecycle(objectIds) {
    const ids = castArray(objectIds)
    return batchUpdateTbDataApi(this.appId, this.tbId, {
      slugs: ['isFakeDeleted'],
      datas: { isFakeDeleted: true },
      objectIds: ids,
    }).then(() => {
      // this.data = omit(this.data, ids)
      // this.processedData = omit(this.processedData, ids)
      this.afterDataDeleted(ids)
      return null
    })
  }

  logsModel() {
    return this.getDitto('tableLog')
  }
}
